var React = require('react');

function Voice (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M15.7 18.3c.3 0 .6-.3.8-.6l2.1-2.8c.2-.3.1-.6-.1-.7l-3.8-2.3a.5.5 0 0 0-.7 0L13 13a2 2 0 0 1-2.9 0L6.5 9.4a2 2 0 0 1 0-2.8l1-1.1c.2-.2.3-.4.2-.6L5.4 1a.5.5 0 0 0-.8 0L1.8 3c-.3.2-.5.5-.6.8-2 6.4 8.1 16.5 14.5 14.5Z","stroke":"#313131","strokeWidth":"1.5"}));
}

Voice.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Voice;

Voice.default = Voice;
